import { Element } from '../../../../../common/html/element'
import { formatVal } from '../../../../../helpers/value'
import { UseScoreRange } from '../../../../score/common/hooks/useScoreRange'
import classes from '../../index.module.scss'

const ScoreCell = ({ val }) => {
  const { creditRange } = UseScoreRange(true, val)
  const backgroundColor = creditRange ? creditRange.scoreRangeCode : '#9C9C9C'

  return (
    <div className="dFlex justifyContentCenter">
      <Element className={classes.scoreItem} style={{ backgroundColor }}>
        <span className="fw600">{formatVal(val, undefined, false, 0)}</span>
      </Element>
    </div>
  )
}

export default ScoreCell
